import { getAccessToken as privyGetAccessToken } from "@privy-io/react-auth";
import { STORAGE_KEYS } from "../../config";
const pageStorage = {
    accessToken: null,
};
export const setAccessToken = (accessToken, saveInCookies = false) => {
    pageStorage.accessToken = accessToken;
    if (saveInCookies) {
        setBrowserStorageAuth(accessToken);
    }
};
export const clearAccessToken = () => {
    console.log("clearAccessToken");
    pageStorage.accessToken = null;
    removeBrowserStorageAuth();
};
export const getAccessToken = async () => {
    if (pageStorage.accessToken) {
        return pageStorage.accessToken;
    }
    else {
        const jwt = getBrowserStorageAuth();
        if (jwt) {
            pageStorage.accessToken = jwt;
            return jwt;
        }
    }
    const accessToken = await privyGetAccessToken();
    if (accessToken) {
        setAccessToken(accessToken);
    }
    return accessToken;
};
const setBrowserStorageAuth = (jwt) => {
    localStorage.setItem(STORAGE_KEYS.auth, jwt);
};
// might need to export only for apollo client to be able to handle 401, TBD
const getBrowserStorageAuth = () => {
    if (typeof window === "undefined") {
        return null;
    }
    return localStorage.getItem(STORAGE_KEYS.auth);
};
const removeBrowserStorageAuth = () => {
    localStorage.removeItem(STORAGE_KEYS.auth);
};
